import { type } from "@testing-library/user-event/dist/type";
import { types } from "../types/types";

const initialState = {
    merchantDetail: null,
    isLoadding: false,
    merchantMapActive: null
}

export const merchantReducer = ( state=initialState, action )=> {

    switch (action.type) {
        // ACTIVE

        case types.merchantDetail:
            return {
                ...state,
                merchantDetail: action.payload
            }
        case types.merchantMapActive:
            return {
                ...state,
                merchantMapActive: action.payload
            }
        default:
            return state;
    }
}